// extracted by mini-css-extract-plugin
export default {"container":"Agreement_container__--T+v","checkbox":"Agreement_checkbox__4JNR0","text":"Agreement_text__NKKIi","invalid":"Agreement_invalid__LOwoK","valid":"Agreement_valid__RBdUt"};